import { type IntlShape } from 'react-intl'

import { directContactFormSubjectPolicyGetByTranslatedSubject } from './directContactFormSubjectPolicySelectors'

export const directContactFormAccessorIsProductType = (
  intl: IntlShape,
  subject: string,
): boolean =>
  directContactFormSubjectPolicyGetByTranslatedSubject({ intl, subject }).policy
    .isProductRelated
